<script setup>
import { ref, inject, onMounted, onUnmounted } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useStorage } from '@/composables/storage'
import { useEchoStore } from '@/stores/echo'
import ringFile from '@/assets/ring.mp3'
import ringChatFile from '@/assets/chat.mp3'

import AccessibleIcon from '@/assets/accessible.svg?component';
import ShoppingCartIcon from '@/assets/shopping-cart.svg?component';
import UserIcon from '@/assets/user.svg?component';

const storage = useStorage()
const router = useRouter()
const user = inject('$user')

if (!user) {
  router.push({ name: 'login' })
}

function setAction(key) {
  if (key === 'logout') {
    storage.clear()
    window.location.href = '/login'
  }
}

const echo = useEchoStore()

const menuState = ref('collapsed')
const menuToggleState = ref('collapsed')

function menuOpen() {
  document.body.classList.add('menu-expanded')
  document.body.classList.remove('menu-collapsed')
  menuToggleState.value = 'expanded'
  menuState.value = 'expanded'
}

function menuClose() {
  document.body.classList.add('menu-collapsed')
  document.body.classList.remove('menu-expanded')
  menuToggleState.value = 'collapsed'
  menuState.value = 'collapsed'
}

const sidebarOpen = ref(false)

function closeSidebarOnClickOutside(e) {
  const sidebar = document.querySelector('.mobile-user-sidebar')
  const toggle = document.querySelector('.mobile-user-toggle')

  if (
      sidebar &&
      !sidebar.contains(e.target) &&
      (!toggle || !toggle.contains(e.target))
  ) {
    sidebarOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeSidebarOnClickOutside)
})
onUnmounted(() => {
  document.removeEventListener('click', closeSidebarOnClickOutside)
})

const iconComponents = {
  menu: AccessibleIcon,
  'shopping-cart': ShoppingCartIcon,
  bell: AccessibleIcon,
  user: UserIcon,
  power: AccessibleIcon,
};

function getIconComponent(iconName) {
  return iconComponents[iconName];
}
</script>

<template>
  <nav class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">
    <div class="navbar-container d-flex content w-100 justify-content-between">

      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item">
          <a class="nav-link menu-toggle" href="#" @click.prevent="menuOpen">
            <vue-feather type="menu" />
          </a>
        </li>
      </ul>

      <audio id="sound-file"><source :src="ringFile" type="audio/mpeg" /></audio>
      <audio id="sound-fileChat"><source :src="ringChatFile" type="audio/mpeg" /></audio>

      <ul class="nav navbar-nav align-items-center ms-auto">
        <li class="nav-item dropdown dropdown-cart me-25">
          <RouterLink :to="{ name: 'orders', query: { status: 'new' } }" class="nav-link">
            <vue-feather type="shopping-cart" size="21" />
<!--            <span class="badge rounded-pill bg-primary badge-up">{{ echo.newOrders }}</span>-->
          </RouterLink>
        </li>

        <li v-if="user" class="nav-item">
          <a href="#" class="nav-link mobile-user-toggle d-xl-none" @click.prevent="sidebarOpen = true">
            <vue-feather type="user" />
          </a>
          <div class="dropdown dropdown-user d-none d-xl-block">
            <a class="nav-link dropdown-toggle dropdown-user-link" href="#" data-bs-toggle="dropdown">
              <div class="user-nav d-sm-flex d-none">
                <span class="user-name fw-bolder">{{ user.email }}</span>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <template v-for="(item, key) in $config.tree.account" :key="key">
                <button v-if="item?.action" @click="setAction(item.action)" class="dropdown-item d-block w-100">
                  <vue-feather class="me-50" :type="item.icon" />
                  {{ $lang('menu.' + key) }}
                </button>
                <RouterLink v-else :to="{ name: key }" class="dropdown-item">
                  <vue-feather class="me-50" :type="item.icon" />
                  {{ $lang('menu.' + key) }}
                </RouterLink>
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>

  <transition name="fade">
    <div v-if="sidebarOpen" class="user-overlay"></div>
  </transition>
  <transition name="slide">
    <div v-if="sidebarOpen" class="mobile-user-sidebar">
    </div>
  </transition>
</template>